import React, { useState, useEffect, useCallback } from 'react';
import './AdminPanel.css';

const AdminCommunityPage = () => {
  const [key, setKey] = useState(() => sessionStorage.getItem('vtd_admin_key') || '');
  const [authed, setAuthed] = useState(false);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ title: '', body: '', date: '', ctaLabel: '', ctaHref: '' });
  const [msg, setMsg] = useState('');

  const load = useCallback(() => {
    if (!key) return;
    setLoading(true);
    fetch('/api/community/posts/all', { headers: { 'x-admin-key': key } })
      .then(r => r.json())
      .then(d => {
        if (d.success) { setPosts(d.posts); setAuthed(true); sessionStorage.setItem('vtd_admin_key', key); }
        else { setAuthed(false); setMsg('Wrong admin key'); }
      })
      .catch(() => setMsg('Network error'))
      .finally(() => setLoading(false));
  }, [key]);

  useEffect(() => { if (key) load(); }, [key, load]);

  const handleAdd = (e) => {
    e.preventDefault();
    setMsg('');
    const payload = {
      title: form.title,
      body: form.body,
      date: form.date,
      cta: form.ctaLabel && form.ctaHref ? { label: form.ctaLabel, href: form.ctaHref } : null,
    };
    fetch('/api/community/posts', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-admin-key': key },
      body: JSON.stringify(payload),
    })
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setForm({ title: '', body: '', date: '', ctaLabel: '', ctaHref: '' });
          setMsg('Post added ✓');
          load();
        } else setMsg(d.error || 'Failed to add');
      });
  };

  const handleDelete = (id) => {
    if (!window.confirm('Delete this post?')) return;
    fetch(`/api/community/posts/${id}`, {
      method: 'DELETE',
      headers: { 'x-admin-key': key },
    }).then(() => load());
  };

  if (!authed) {
    return (
      <div className="adm">
        <div className="adm__login">
          <h1>Admin · Community</h1>
          <p className="adm__sub">Enter admin key to manage posts.</p>
          <input
            type="password"
            placeholder="Admin key"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && load()}
          />
          <button onClick={load} disabled={loading}>{loading ? 'Checking…' : 'Unlock'}</button>
          {msg && <p className="adm__err">{msg}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="adm">
      <header className="adm__header">
        <h1>Admin · Community ({posts.length})</h1>
        <a className="adm__nav" href="/admin/reviews">→ Reviews</a>
      </header>

      <section className="adm__card">
        <h2>New Post</h2>
        <form className="adm__form" onSubmit={handleAdd}>
          <input placeholder="Title" required
            value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          <textarea placeholder="Body" rows={4} required
            value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} />
          <input placeholder="Date (e.g. 18 May 2026 — leave blank for today)"
            value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} />
          <div className="adm__row">
            <input placeholder="CTA label (optional)" value={form.ctaLabel}
              onChange={(e) => setForm({ ...form, ctaLabel: e.target.value })} />
            <input placeholder="CTA link (optional)" value={form.ctaHref}
              onChange={(e) => setForm({ ...form, ctaHref: e.target.value })} />
          </div>
          <button type="submit">Publish Post</button>
          {msg && <span className="adm__msg">{msg}</span>}
        </form>
      </section>

      <section className="adm__card">
        <h2>All Posts</h2>
        {!posts.length && <p className="adm__sub">No posts yet.</p>}
        <ul className="adm__list">
          {posts.map(p => (
            <li key={p.id} className={`adm-item${p.published === false ? ' adm-item--draft' : ''}`}>
              <div className="adm-item__main">
                <div className="adm-item__head">
                  <strong>{p.title}</strong>
                  <span className="adm-item__svc">{p.date}</span>
                </div>
                <p className="adm-item__text">{p.body}</p>
                {p.cta && <a href={p.cta.href}>{p.cta.label} →</a>}
              </div>
              <div className="adm-item__actions">
                <button className="adm-btn--danger" onClick={() => handleDelete(p.id)}>Delete</button>
              </div>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default AdminCommunityPage;
